import React from 'react'
import PropTypes from 'prop-types'

// components
import { CheckBox, Input, Divider, Select } from '@st-operations/uikit/src/v2'
import Header from '_components/header'
import Distribution from '../distribution'
import { PERCENTILE_TAXONOMY_NAME } from '../constants'

// lib
import pretty from '@st-operations/uikit/lib/pretty'

const TaxonomyForm = ({
  headerActions,
  title,
  fields,
  distributions,
  taxonomyId,
  values,
  handleChange,
  needMappingIds,
  setError,
  setNeedMappingIds,
}) => {
  const handleSelectChange = (field, value) => {
    const updatedValue = value.value
    if (field.name === 'need_mapping_ids') {
      setNeedMappingIds(updatedValue)
    } else {
      handleChange(field, updatedValue)
    }
  }

  const handleCheckboxChange = (e, field) => {
    const targetChecked = e.target.checked
    handleChange(field, targetChecked)
  }

  return (
    <>
      <Header actions={headerActions} title={title} />
      <div className="taxonomy__fields-wrapper">
        <For each="field" of={fields}>
          <Choose>
            <When condition={field.type === 'text'}>
              <Input
                key={field.name}
                name={field.name}
                label={field.label ?? pretty(field.name)}
                value={values[field.name]}
                onChange={(value) => handleChange(field, value)}
                description={field.description ?? ''}
                containerStyle={{ gridColumn: field.position }}
                disabled={
                  field.disabled ||
                  (field.name === 'name' && values.name === PERCENTILE_TAXONOMY_NAME)
                }
              />
            </When>
            <When condition={field.type === 'select'}>
              <Select
                key={field.name}
                name={field.name}
                label={field.label ?? pretty(field.name)}
                description={field.description ?? ''}
                style={{ gridColumn: field.position }}
                value={field.name !== 'need_mapping_ids' ? values[field.name] : needMappingIds}
                onChange={(value) => handleSelectChange(field, value)}
                options={field.options ?? []}
                useReactSelect={field.useReactSelect ?? false}
                isSearchable={field.isSearchable ?? false}
                isMulti={field.isMulti ?? false}
              />
            </When>
            <When condition={field.type === 'checkbox'}>
              <CheckBox
                key={field.name}
                containerStyle={{
                  gridColumn: field.position,
                  alignItems: 'center',
                  display: 'flex',
                  justifyContent: 'center',
                  width: '100% ',
                }}
                label={
                  <span style={{ fontSize: '14px', fontWeight: '600' }}>
                    {field.label ?? pretty(field.name)}
                  </span>
                }
                checked={Boolean(values[field.name])}
                onChange={(e) => handleCheckboxChange(e, field)}
              />
            </When>
          </Choose>
        </For>
      </div>
      <Divider />
      <Distribution
        segmentsConfig={values.new_segments_config}
        needSegmentIds={needMappingIds?.value ?? false}
        slug={values.slug}
        handleChange={handleChange}
        setError={setError}
        distributions={distributions}
        taxonomyId={taxonomyId}
        taxonomyName={title}
      />
    </>
  )
}

TaxonomyForm.defaultProps = {
  needMappingIds: null,
}

TaxonomyForm.propTypes = {
  title: PropTypes.string.isRequired,
  fields: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      description: PropTypes.string,
      disabled: PropTypes.bool,
      position: PropTypes.string,
      type: PropTypes.string,
    })
  ).isRequired,
  headerActions: PropTypes.arrayOf(
    PropTypes.shape({
      children: PropTypes.any,
      onClick: PropTypes.func,
      theme: PropTypes.string,
    })
  ).isRequired,
  values: PropTypes.shape({
    name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    distribution: PropTypes.array.isRequired,
  }),
  distributions: PropTypes.arrayOf(
    PropTypes.shape({
      destination: PropTypes.string,
      geo: PropTypes.array,
      prefix: PropTypes.string,
      mapping_ids: PropTypes.string,
      lookback: PropTypes.string,
    })
  ).isRequired,
  setError: PropTypes.func,
  handleChange: PropTypes.func.isRequired,
  needMappingIds: PropTypes.bool,
  setNeedMappingIds: PropTypes.func.isRequired,
  taxonomyId: PropTypes.string,
}

export default TaxonomyForm
